import React from 'react';
import { CalendarIcon, UserIcon } from 'lucide-react';
export const RecentBlogs = () => {
  const blogs = [{
    id: 1,
    title: 'Top 5 Hidden Trails in Zakynthos',
    excerpt: 'Discover the secret paths of Zakynthos that most tourists never see, offering stunning views and peaceful hikes.',
    image: 'https://images.unsplash.com/photo-1602088693770-a2adc828d239?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1167&q=80',
    date: 'July 15, 2023',
    author: 'Maria K.',
    category: 'Greece'
  }, {
    id: 2,
    title: 'Hiking Essentials: What to Pack for Mediterranean Trails',
    excerpt: 'Our comprehensive guide to packing for hiking trips in Mediterranean climates, with tips from experienced guides.',
    image: 'https://images.unsplash.com/photo-1519681393784-d120267933ba?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80',
    date: 'July 8, 2023',
    author: 'Thomas L.',
    category: 'Tips & Guides'
  }, {
    id: 3,
    title: 'Local Cuisine: Tasting Your Way Through Cyprus',
    excerpt: "Explore the delicious flavors of Cypriot cuisine that you'll encounter during our hiking adventures on the island.",
    image: 'https://images.unsplash.com/photo-1573979538919-4ae03fc2b173?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1074&q=80',
    date: 'June 30, 2023',
    author: 'Elena P.',
    category: 'Cyprus'
  }, {
    id: 4,
    title: 'Sustainable Hiking: How We Minimize Our Environmental Impact',
    excerpt: 'Learn about our commitment to sustainable tourism and the steps we take to preserve the beautiful trails we hike.',
    image: 'https://images.unsplash.com/photo-1682687982501-1e58ab814714?ixlib=rb-4.0.3&ixid=M3wxMjA3fDF8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80',
    date: 'June 22, 2023',
    author: 'Alex M.',
    category: 'Sustainability'
  }];
  return <section id="blogs" className="py-16 w-full" data-id="element-181">
      <div className="container mx-auto px-4" data-id="element-182">
        <div className="text-center mb-12" data-id="element-183">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4" data-id="element-184">
            Latest From Our Blog
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-185">
            Insights, tips, and stories from our hiking adventures
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-186">
          {blogs.map(blog => <div key={blog.id} className="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-lg transition duration-300" data-id="element-187">
              <div className="h-48 overflow-hidden" data-id="element-188">
                <img src={blog.image} alt={blog.title} className="w-full h-full object-cover transform hover:scale-105 transition duration-500" data-id="element-189" />
              </div>
              <div className="p-6" data-id="element-190">
                <div className="flex justify-between items-center mb-3" data-id="element-191">
                  <span className="text-xs font-medium text-white bg-teal-600 px-2 py-1 rounded-full" data-id="element-192">
                    {blog.category}
                  </span>
                  <div className="flex items-center text-gray-500 text-sm" data-id="element-193">
                    <CalendarIcon size={14} className="mr-1" data-id="element-194" />
                    {blog.date}
                  </div>
                </div>
                <h3 className="text-lg font-bold text-gray-800 mb-2" data-id="element-195">
                  {blog.title}
                </h3>
                <p className="text-gray-600 text-sm mb-4" data-id="element-196">{blog.excerpt}</p>
                <div className="flex justify-between items-center" data-id="element-197">
                  <div className="flex items-center text-gray-500 text-sm" data-id="element-198">
                    <UserIcon size={14} className="mr-1" data-id="element-199" />
                    {blog.author}
                  </div>
                  <a href={`/blog/${blog.id}`} className="text-teal-600 hover:text-teal-700 font-medium text-sm" data-id="element-200">
                    Read More →
                  </a>
                </div>
              </div>
            </div>)}
        </div>
        <div className="text-center mt-10" data-id="element-201">
          <a href="/blog" className="inline-block border-2 border-teal-600 text-teal-600 hover:bg-teal-600 hover:text-white font-medium py-2 px-6 rounded-md transition duration-300" data-id="element-202">
            View All Posts
          </a>
        </div>
      </div>
    </section>;
};